import React, {Component} from 'react';
import {Link} from 'react-router';

import SNIntro from './components/sn_intro';
import Perks from './components/perks';
import Footer from 'js/components/footer';

export default class RecruitingManager extends Component {
    render() {
        return (
            <div id="job-page">
                <header className="header-blue">
                    <div id="sn-logo" className="hide show@sm">
                        <Link to="/">

                        </Link>
                    </div>
                    <div id="sn-logo-mobile" className="hide@sm">
                        <Link to="/">

                        </Link>
                    </div>
                    <div className="header-title">
                        <h2>Recruiting Manager</h2>
                        <Link to="/jobs">Back To Jobs</Link>
                    </div>
                </header>
                <section id="policy">
                    <div className="terms-body">
                        <SNIntro />

                        <p className="p2">
                            We are seeking a <b>Recruiting Manager</b> to bring in top talent, streamline our recruiting process, and implement HR and Recruiting groundwork.
                        </p>

                        <p className="p1"><span className="s1"><b>Responsibilities</b></span></p>
                        <ul className="l1">
                            <li className="p3">
                                Manage the full cycle of our small recruiting team and help our company scale - focus on building pipelines, guiding candidates through the process, and supporting hiring teams by helping them find their new team members.
                            </li>
                            <li className="p3">
                                Work closely with team managers to build a seamless interview process that helps us bring the best candidates to our teams.
                            </li>
                            <li className="p3">
                                Work with the executive team to set and execute on organizational design and lead long-term vision for people functions - creating and maintaining a high-performing, motivated, and impactful team aligned with our overall business goals.
                            </li>
                            <li className="p3">
                                Partner with leaders to understand and anticipate hiring and development needs against the capabilities needed to deliver business objectives; prepare updated workforce plans and forecasts that support overall business goals.
                            </li>
                            <li className="p3">
                                {`Ensure that all decisions, programs, and processes are aligned with Social Native's culture and core values.`}
                            </li>
                            <li className="p3">
                                Identify most effective tools to hunt relevant candidates, manage candidate tracking, and optimize job listings.
                            </li>
                        </ul>

                        <p className="p1"><span className="s1"><b>Skills & Qualifications</b></span></p>
                        <ul className="l1">
                            <li className="p3">
                                5+ years recruiting and hiring top talent across all levels of the business.
                            </li>
                            <li className="p3">
                                3+ years HR / People Ops experience in a high growth company.
                            </li>
                            <li className="p3">
                                You have experienced and love startup life, embrace the absurdity and rapid growth, and shrink any notions of HR being "the fun police".
                            </li>
                            <li className="p3">
                                You have the proven ability to influence and drive change with executive teams and across agile organizations, aligning the people strategy with business goals and maintaining effective relationships with employees.
                            </li>
                            <li className="p3">
                                Experience growing early stage, high growth start-up from few to many.
                            </li>
                            <li className="p3">
                                Experience building and maintaining strong, long-lasting pipelines.
                            </li>
                            <li className="p3">
                                Target-driven with ability to stay ambitious and hungry to hire.
                            </li>
                            <li className="p3">
                                A background working within a recruiting firm and in-house is a plus.
                            </li>
                            <li className="p3">
                                Experience in technical recruiting is a plus.
                            </li>
                            <li className="p3">
                                BA/BS degree or equivalent.
                            </li>
                        </ul>

                        <Perks />

                        <div className="link">
                            <a href="mailto:info@socialnative.com">
                                Interested? Shoot us a note telling us why.
                            </a>
                        </div>
                    </div>
                </section>
                <Footer dontShowJobs={true}/>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./web/js/pages/jobs_pages/recruiting_manager.js